import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, of, tap} from 'rxjs';
import {NgEventBus} from 'ng-event-bus';
import {AppConfigService} from './app-config.service';
import {WindowWidgetsService} from '../../design/window-widgets/window-widgets.service';

@Injectable({
    providedIn: 'root'
})
export class LookupService {
    constructor(
        private http: HttpClient,
        private eventBus: NgEventBus,
        private appConfigService: AppConfigService,
        private windowWidgetsService: WindowWidgetsService
    ) {}

    allLookups = {};
    lookupsLoaded = false;
    getAllLookups() {
        return this.allLookups;
    }

    loadAllLookups() {
        if (this.lookupsLoaded) {
            return of(null);
        }

        const url = this.appConfigService.settings.apiGatewayUrl + '/lookups';
        return this.http.get(url).pipe(
            tap({
                next: data => {
                    console.log('loadAllLookups start');
                    Object.keys(data).forEach(k => (this.allLookups[k] = data[k]));
                    console.log('loadAllLookups stop');
                },
                error: error => {
                    console.error('Lookups Load failed ' + error.message);
                },
                complete: () => {
                    this.lookupsLoaded = true;
                    this.eventBus.cast('nlr:lookups-loaded');
                }
            })
        );
    }

    getLookups<T>(path: string, includeInactive?: boolean) {
        path = path.replace(/(Lookup)s?$/, '');

        if (!this.allLookups[path]) {
            console.log(`getLookup(${path}) - missing lookup`);
            return {};
        }

        return this.windowWidgetsService.structuredClone(
            this.allLookups[path].filter((l: {active: boolean}) => l.active === undefined || includeInactive || l.active)
        )<T[]>;
    }

    retrieveLookup<T>(path: string): Observable<T> {
        console.log(`getLookups is invoked with the path ` + path);
        return this.http.get<T>(this.appConfigService.settings.apiGatewayUrl + path);
    }
}
